import { EXPIRED, NOT_SUBSCRIBED, SKIPPED } from './boxStatusId';

export const isAddressVisible = (boxStatusId: string) =>
  boxStatusId !== EXPIRED && boxStatusId !== SKIPPED && boxStatusId !== NOT_SUBSCRIBED;
